(() => {
  if (window.__bfInfoDrawers) return;
  window.__bfInfoDrawers = true;
  let active = null, opener = null, oldOverflow = '';
  const syncVariant = dialog => {
    const data = dialog.querySelector('[data-bf-drawer-variants]');
    if (!data) return;
    const id = document.getElementById(dialog.dataset.productForm)?.querySelector('[name="id"]')?.value;
    const variant = JSON.parse(data.textContent).find(v => String(v.id) === String(id));
    if (!variant) return;
    dialog.querySelector('[data-bf-drawer-format]').textContent = /c[aá]p/i.test(variant.title) ? '60 cápsulas' : /100\s*g/i.test(variant.title) ? 'Polvo · 100 g' : variant.title;
    const img = dialog.querySelector('.bf-info-drawer__image');
    const source = variant.featured_image?.src;
    if (img && source) { img.removeAttribute('srcset'); img.src = source; }
  };
  const cleanUp = dialog => {
    if (active !== dialog) return;
    document.documentElement.style.overflow = oldOverflow;
    opener?.setAttribute('aria-expanded', 'false');
    const previous = opener;
    active = null; opener = null;
    if (previous?.isConnected) previous.focus({preventScroll:true});
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-bf-drawer-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.bfDrawerOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (active === dialog) return;
      if (active) { const previous = active; previous.close(); cleanUp(previous); }
      syncVariant(dialog);
      opener = trigger; active = dialog;
      oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');
      dialog.addEventListener('close', () => cleanUp(dialog), {once:true});
      dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-bf-drawer-close]');
    if (close) close.closest('dialog').close();
    if (event.target === active) {
      const r = active.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) active.close();
    }
  });
  document.addEventListener('shopify:section:unload', event => {
    if (active && event.target.contains(active)) { active.close(); cleanUp(active); }
  });
})();
